// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-AFc","input":"styles_input__2A_Y_"};